import type { LucideIcon } from "lucide-react";

type TrialCalendarTileProps = {
  dayLabel: string;
  icon: LucideIcon;
};

export function TrialCalendarTile({ dayLabel, icon: Icon }: TrialCalendarTileProps) {
  return (
    <div
      className="flex h-[3.75rem] w-14 shrink-0 flex-col overflow-hidden rounded-lg shadow-sm"
      aria-hidden
    >
      <div className="flex h-[1.125rem] items-center justify-center bg-[oklch(68%_0.12_65)] px-1">
        <span className="truncate text-[0.5625rem] font-semibold uppercase tracking-wide text-[oklch(98%_0.01_85)]">
          {dayLabel}
        </span>
      </div>

      <div className="flex flex-1 items-center justify-center bg-[oklch(93%_0.02_90)]">
        <Icon
          size={22}
          strokeWidth={1.75}
          className="text-[oklch(42%_0.06_55)]"
          aria-hidden
        />
      </div>
    </div>
  );
}
